import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Pagination = ({ page, pages, onPageChange }) => {
    if (pages <= 1) return null;

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const maxVisiblePages = 5;
        let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(pages, startPage + maxVisiblePages - 1);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    onClick={() => onPageChange(i)}
                    className={`w-10 h-10 rounded-xl font-bold transition-all shadow-sm ${
                        page === i
                            ? 'bg-primary text-white shadow-primary/20'
                            : 'bg-white text-gray-600 hover:bg-surface-muted'
                    }`}
                >
                    {i}
                </button>
            );
        }
        return pageNumbers;
    };

    return (
        <div className='flex items-center justify-center gap-2 mt-8 pb-4'>
            <button
                onClick={() => onPageChange(page - 1)}
                disabled={page === 1}
                className={`w-10 h-10 rounded-xl flex items-center justify-center bg-white text-gray-500 shadow-sm transition-all hover:bg-surface-muted disabled:opacity-30 disabled:cursor-not-allowed`}
            >
                <FaChevronLeft size={12} />
            </button>
            
            <div className='flex items-center gap-2'>
                {renderPageNumbers()}
            </div>

            <button
                onClick={() => onPageChange(page + 1)}
                disabled={page === pages}
                className={`w-10 h-10 rounded-xl flex items-center justify-center bg-white text-gray-500 shadow-sm transition-all hover:bg-surface-muted disabled:opacity-30 disabled:cursor-not-allowed`}
            >
                <FaChevronRight size={12} />
            </button>
        </div>
    );
};

export default Pagination;
